import { render, staticRenderFns } from "./BrandDetails.vue?vue&type=template&id=40427728"
import script from "./BrandDetails.vue?vue&type=script&lang=ts"
export * from "./BrandDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports